export default __webpack_public_path__ + "static/media/switch-logo.f42d62f5.svg";